// 表示中のrequired入力に対応するラベルへ「※必須」を付与するユーティリティ
export function applyRequiredBadges(rootSelector = '.medichat-main-content') {
  try {
    const root = document.querySelector(rootSelector) || document;
    const requiredInputs = root.querySelectorAll('input[required], textarea[required], select[required]');
    requiredInputs.forEach((el) => {
      // 非表示は対象外
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (el.offsetParent === null) return;
      
      // ラベルを探索（フィールドコンテナ内）
      const field = el.closest('.basic-info-field, .medichat-form-field, .basic-info-number, .medichat-textarea-container');
      if (!field) return;
      const label = field.querySelector('label.basic-info-label') || field.querySelector('label');
      if (!label) return;
      
      if (!label.classList.contains('required')) {
        label.classList.add('required');
      }
    });
  } catch (e) {
    // 失敗してもアプリには影響させない
    console.debug('[requiredBadge] skipped:', e?.message);
  }
}


